import React, { useEffect } from 'react';
import useGame from '@monorepo/shared/src/hooks/use-game';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import SoundOutWordsActivity from '../SoundOutWordsActivity';
import ProgressProvider from '@monorepo/shared/src/providers/ProgressProvider';
import FindTheLetterActivity from '../FindTheLetterActivity';
import FindTheObjectActivity from '../FindTheObjectActivity';
import useOverlay from '@monorepo/shared/src/hooks/use-overlay';
import { useParams } from 'react-router-dom';

const allActivities = {
  SoundOutWords: SoundOutWordsActivity,
  FindTheLetter: FindTheLetterActivity,
  FindTheObjects: FindTheObjectActivity,
};

type ActivityContainerProps = {
  backRoute?: string;
};

const ActivityContainer: React.FC<ActivityContainerProps> = ({ backRoute }) => {
  const [{ isRestarting, loading }, { handleCurrentPageCompletionWithAlert }] = useGame();
  const params = useParams();
  const [, { setShowOverlay }] = useOverlay();

  const Activity = allActivities[params.activityType ?? ''];

  useEffect(() => {
    setShowOverlay(false);
  }, []);

  return (
    <WithQuery loading={loading}>
      {!isRestarting && (
        <ProgressProvider handlePageCompletion={handleCurrentPageCompletionWithAlert}>
          <Activity activityType={params.activityType} backRoute={backRoute} hasHeader={true} />
        </ProgressProvider>
      )}
    </WithQuery>
  );
};

export default ActivityContainer;
